"use client";
import React from 'react';
import { Layout, Space, Typography } from '@sravni/react-design-system';
import { useStyles, useAnalytics, useIsMobile } from '@sravni/react-utils/lib/hooks';
import { useIntersectionObservers } from '../../hooks/useIntersectionObservers.js';
import { AppStoresList } from '../AppStoresList/AppStoresList.js';
import img from './images/Phone.png.js';
import img$1 from './images/Qr.svg.js';
import modules_6e57ada8 from './MobileApp.module.less.js';

const { Heading, UnorderedList, ListItem } = Typography;
/**
 * @description Mobile application links block of footer.
 *
 * @component
 * @example
 * ```jsx
 * <MobileApp />
 * ```
 */
const MobileApp = React.forwardRef((props, ref) => {
    const { className, ...restProps } = props;
    const cx = useStyles(modules_6e57ada8);
    const { pushEvent } = useAnalytics();
    const isMobile = useIsMobile();
    const handleElementInView = React.useCallback((inView, entry) => {
        if (inView && (entry.target instanceof HTMLElement || entry.target instanceof SVGSVGElement)) {
            const store = entry.target.dataset.store || '';
            pushEvent({
                event: 'mainEvent',
                eventCategory: 'Футер',
                eventAction: 'Показ ссылки в Store',
                eventLabel: `Футер|${store}`,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { refs } = useIntersectionObservers({
        ids: ['qr', "GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */, "APPLE_STORE" /* APP_STORES.APPLE_STORE */, "HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */, "RU_STORE" /* APP_STORES.RU_STORE */],
        callback: handleElementInView,
    });
    return (React.createElement("div", { ref: ref, className: cx('wrapper') },
        React.createElement(Layout, { className: cx('layout'), ...restProps },
            React.createElement(Space, { justify: "space-between", align: "center" },
                React.createElement(Space, { direction: "vertical", justify: "center", className: cx('leftSide') },
                    React.createElement(Heading, { level: 4, as: "div", className: "h-mb-8" }, "\u0421\u0440\u0430\u0432\u043D\u0438 \u2014 \u0432 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438"),
                    isMobile && React.createElement(AppStoresList, { refs: refs }),
                    React.createElement(UnorderedList, { className: cx('list') },
                        React.createElement(ListItem, null, "\u041E\u0444\u043E\u0440\u043C\u043B\u044F\u0439\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u043E\u043D\u043B\u0430\u0439\u043D"),
                        React.createElement(ListItem, null, "\u0425\u0440\u0430\u043D\u0438\u0442\u0435 \u043F\u043E\u043B\u0438\u0441\u044B, \u0447\u0435\u043A\u0438 \u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439"),
                        React.createElement(ListItem, null, "\u041E\u0446\u0435\u043D\u0438\u0432\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438"))),
                React.createElement(Space, { align: "center", size: 16, className: cx('rightSide') },
                    React.createElement(Space, { className: cx('imageWrapper') },
                        React.createElement("img", { height: 270, width: 250, src: img, alt: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435", className: cx('image') })),
                    React.createElement("img", { ref: refs.qr, "data-store": "QR", className: cx('qr'), src: img$1, alt: "Download App" }),
                    React.createElement(Space, { direction: "vertical", className: cx('downloadInfo') },
                        React.createElement(Heading, { level: 4, as: "div", className: cx('downloadTitle', 'downloadDescription') }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0441\u00A0\u043F\u043E\u043C\u043E\u0449\u044C\u044E QR\u2011\u043A\u043E\u0434\u0430"),
                        !isMobile && React.createElement(AppStoresList, { refs: refs })))))));
});
MobileApp.displayName = 'MobileApp';

export { MobileApp };
//# sourceMappingURL=MobileApp.js.map
